import { getAccountByTenantId } from "../../utils/accountUtils";

const fetchAllItems = async (instance, account, url) => {
  let allItems = [];
  let nextLink = url;

  while (nextLink) {
    try {
      const response = await instance.acquireTokenSilent({
        scopes: ["https://graph.microsoft.com/.default"],
        account: account,
      });

      const result = await fetch(nextLink, {
        headers: {
          Authorization: `Bearer ${response.accessToken}`,
        },
      });

      if (!result.ok) {
        throw new Error(`HTTP error! status: ${result.status}`);
      }

      const data = await result.json();
      
      // Check if data.value exists and is an array
      if (!data || !Array.isArray(data.value)) {
        console.error('Invalid response format:', data);
        throw new Error('Invalid response format from API');
      }

      allItems = [...allItems, ...data.value];
      nextLink = data["@odata.nextLink"];
    } catch (error) {
      console.error('Error fetching items:', error);
      throw error;
    }
  }

  return allItems;
};

export const fetchDropdownOptions = async (instance, accounts, tenantId) => {
  try {
    const account = getAccountByTenantId(accounts, tenantId);
    const baseUrl = `${process.env.REACT_APP_GRAPH_API_URL}/sites/${process.env.REACT_APP_SP_SITE_ID}/lists/${process.env.REACT_APP_DROPDOWN_LIST_ID}/items?$expand=fields`;
    
    const items = await fetchAllItems(instance, account, baseUrl);
    
    // Process items to create the dropdown options object
    const dropdownOptions = items.reduce((acc, item) => {
      const { Title, field_1 } = item.fields;
      const key = Title.toLowerCase();
      
      if (!acc[key]) {
        acc[key] = [];
      }
      
      // Add field_1 if it exists and is not already in the array
      if (field_1 && !acc[key].includes(field_1)) {
        acc[key].push(field_1);
      }
      
      return acc;
    }, {});

    return dropdownOptions;
  } catch (error) {
    console.error("Error fetching dropdown options:", error);
    throw error;
  }
}; 